export const RENDER_MODES = {
  CANVAS: 'canvas' as const,
  SVG: 'svg' as const,
} as const;
